import React from 'react';
import ReactDOM from 'react-dom';
import { DivOverallWrap } from '../../../../react/components/utility/wrap';
import { PrivacyPolicy } from '../../../../react/pages/legal/privacy_policy/privacyPolicy';


document.addEventListener('DOMContentLoaded', () => {
  const domToBinding = document.getElementById('react-legal-privacy_policy-root')!;
  if(domToBinding == null) return

  ReactDOM.render(
    <div style={{backgroundColor: '#f0f0f0'}}>
      <DivOverallWrap style={{paddingBottom: 0, backgroundColor: '#f0f0f0'}}>
        <PrivacyPolicy/>
      </DivOverallWrap>
    </div>,
    domToBinding);
});

